/* Smart Electric mega menu: hover (with delay), click, keyboard. One panel open at a time. */
(() => {
  if (window.SeMegaMenu) return;
  class SeMegaMenu {
    constructor(nav) {
      if (nav.dataset.seMegaReady) return;
      nav.dataset.seMegaReady = '1';
      this.nav = nav;
      this.delay = parseInt(nav.dataset.hoverDelay || '150', 10);
      this.items = Array.from(nav.querySelectorAll('[data-se-mega-item]'));
      this.overlay = nav.querySelector('[data-se-mega-overlay]');
      this.wrapper = nav.closest('.header-wrapper') || nav.closest('header');
      this.openItem = null;
      this.timer = null;
      this.hoverOpened = false;
      this.fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.items.forEach((li) => this.bindItem(li));
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      this.onKey = (e) => {
        if (e.key !== 'Escape' || !this.openItem) return;
        const btn = this.openItem.querySelector('.se-mega__trigger');
        this.close();
        btn && btn.focus();
      };
      this.onDocClick = (e) => { if (this.openItem && !this.openItem.contains(e.target)) this.close(); };
      this.onScroll = () => { if (this.openItem) this.position(this.openItem); };
      this.onResize = () => { if (!window.matchMedia('(min-width: 990px)').matches) this.close(); else if (this.openItem) this.position(this.openItem); };
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }
    schedule(fn, ms) { clearTimeout(this.timer); this.timer = setTimeout(fn, ms); }
    bindItem(li) {
      const btn = li.querySelector('.se-mega__trigger');
      const panel = li.querySelector('.se-mega__panel');
      if (!btn || !panel) return;
      li.addEventListener('mouseenter', () => {
        if (!this.fine.matches) return;
        if (this.openItem === li) { clearTimeout(this.timer); return; }
        this.schedule(() => { this.open(li); this.hoverOpened = true; }, this.openItem ? Math.min(60, this.delay) : this.delay);
      });
      li.addEventListener('mouseleave', () => {
        if (!this.fine.matches) return;
        this.schedule(() => { if (this.openItem === li) this.close(); else clearTimeout(this.timer); }, this.delay + 100);
      });
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        clearTimeout(this.timer);
        if (this.openItem === li) {
          if (this.hoverOpened) { this.hoverOpened = false; return; } // first click after hover just pins it open
          this.close();
        } else {
          this.open(li);
          this.hoverOpened = false;
        }
      });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (this.openItem !== li) { this.open(li); this.hoverOpened = false; }
          const first = panel.querySelector('a');
          first && first.focus();
        }
      });
      li.addEventListener('focusout', (e) => {
        if (e.relatedTarget && !li.contains(e.relatedTarget) && this.openItem === li) this.close();
      });
    }
    position(li) {
      const panel = li.querySelector('.se-mega__panel');
      const label = li.querySelector('.se-mega__trigger');
      const ref = this.wrapper || panel.offsetParent || document.body;
      const r = ref.getBoundingClientRect();
      const t = label.getBoundingClientRect();
      panel.style.setProperty('--se-bar-x', `${Math.round(t.left - r.left)}px`);
      panel.style.setProperty('--se-bar-w', `${Math.round(t.width)}px`);
      if (this.overlay) this.overlay.style.setProperty('--se-overlay-top', `${Math.max(0, Math.round(panel.getBoundingClientRect().bottom))}px`);
    }
    open(li) {
      if (this.openItem && this.openItem !== li) this.hide(this.openItem);
      const btn = li.querySelector('.se-mega__trigger');
      const panel = li.querySelector('.se-mega__panel');
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      li.classList.add('is-open');
      this.openItem = li;
      this.position(li);
      if (this.overlay) this.overlay.hidden = false;
      this.nav.classList.add('se-mega--open');
    }
    hide(li) {
      const btn = li.querySelector('.se-mega__trigger');
      const panel = li.querySelector('.se-mega__panel');
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      li.classList.remove('is-open');
    }
    close() {
      clearTimeout(this.timer);
      if (this.openItem) this.hide(this.openItem);
      this.openItem = null;
      this.hoverOpened = false;
      if (this.overlay) this.overlay.hidden = true;
      this.nav.classList.remove('se-mega--open');
    }
  }
  window.SeMegaMenu = SeMegaMenu;
  const init = (root) => root.querySelectorAll('[data-se-mega]').forEach((nav) => new SeMegaMenu(nav));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
